window.addEventListener("DOMContentLoaded", () => {
    let imageBanners = document.querySelectorAll(
        ".image-banner.topleft-topright, .video-banner"
    );
    let imageBannersAll = document.querySelectorAll(
        ".image-banner, .video-banner"
    );
    if (imageBanners) {
        gsap.registerPlugin(ScrollTrigger);
        imageBanners.forEach((banner) => {
            let text = banner.querySelector(".text-content");
            let ctas = banner.querySelector(".banner__cta_container");

            if (text) {
                let header = text.querySelector("h2");

                if (header) {
                    if (header.classList.contains("centered")) {
                        if (ctas) {
                            text.classList.add("center-mobile");
                        }
                    }

                    if (header.classList.contains("centered")) {
                        banner.classList.add("center");
                    } else {
                        let headerHeight =
                            document.querySelector(
                                "sticky-header"
                            ).offsetHeight;
                        let announcementBar = document.querySelector(
                            "#shopify-section-announcement-bar .announcement-bar.top"
                        );
                        if (announcementBar) {
                            headerHeight += announcementBar.offsetHeight;
                        }
                        let bottom =
                            banner.offsetHeight -
                            text.offsetHeight -
                            headerHeight;

                        gsap.timeline({
                            scrollTrigger: {
                                pin: true,
                                pinSpacing: false,
                                trigger: text,
                                start: "top " + headerHeight + "px",
                                end: () => `$+=${bottom}`,
                                pinSpacing: true,
                                invalidateOnRefresh: true,
                                scrub: true,
                            },
                        });
                    }
                }

                setTimeout(() => {
                    text.classList.add("show");
                }, 200);
            }

           
        });
    }

    if(imageBannersAll){
        imageBannersAll.forEach((banner) => {
            let ctas = banner.querySelector(".banner__cta_container");

          
            if (banner.classList.contains("clickable")) {
                banner.addEventListener("click", function () {
       
                    let cta = banner.querySelector(".banner__cta:first-child");
                    if (cta) {
                        cta.click();
                    }
                });
            }
        });
    }
});
